import React, { useEffect, useRef } from 'react';
import { clientLogos } from '../data/mock';

const ClientLogos = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) entry.target.classList.add('visible'); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Duplicate logos for seamless loop
  const allLogos = [...clientLogos, ...clientLogos];

  return (
    <section ref={sectionRef} className="reveal py-16 sm:py-20 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-semibold text-slate-400 uppercase tracking-widest mb-10 font-heading">
          Trusted by enterprises and funded startups
        </p>
      </div>

      {/* Marquee container */}
      <div className="relative overflow-hidden">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 z-10" style={{ background: 'linear-gradient(to right, white, transparent)' }} />
        <div className="absolute right-0 top-0 bottom-0 w-32 z-10" style={{ background: 'linear-gradient(to left, white, transparent)' }} />

        <div className="marquee-track flex items-center gap-16 sm:gap-20 w-max">
          {allLogos.map((client, index) => (
            <div key={index} className="flex-shrink-0 flex items-center justify-center px-2">
              <img
                src={client.url}
                alt={`${client.name} logo`}
                className="h-7 sm:h-9 w-auto opacity-40 hover:opacity-80 transition-all duration-300 grayscale hover:grayscale-0"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
